import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import { addToFavorites, removeFromFavorites } from 'actions/favorites';
import iconUpdate from 'assets/images/icons/update-arrows.svg';
import { updateString, updateStringPrint } from 'utils';
// import Marker from 'react-icons/lib/fa/map-marker';

import ChessLink from 'components/Building/Main/ChessLink';
import Print from 'components/Building/Print';
import ShareButton from 'components/ShareButton';
import Collections from 'components/Building/Main/Collections';
import Loader from 'components/common/Loader';

import cn from 'classnames/bind';
import styles from './BuildingTitle.scss';

import iconHeart from 'assets/images/icons/icon-heart.svg';
import iconHeartActive from 'assets/images/icons/icon-heart-active.svg';
import iconVerified from 'assets/images/icons/icon-verified.svg';
import logoPrint from 'assets/images/logo-black.svg';
import tracker from '../../../services/tracker';
import { withTranslation } from 'react-i18next';
import { isSectionAllowed } from '../../Building/Main/helper';
import InaccuracyReport from '../../Building/InaccuracyReport';
import { gaEvent, trackGA } from 'services/ga';

class BuildingTitle extends Component {
  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll(event) {
    const scrollTop = event.srcElement.body.scrollTop;
    this.setState({ onTop: scrollTop === 0 });
  }

  sendEvent = (event) => {
    const { id, title } = this.props.data || {};

    tracker.sendEvent(event, {
      id,
      name: title,
    });
  };

  handleTrackEvent = ({ eventName, buttonName }) => {
    const { profile, objectType, data } = this.props;
    trackGA(
      gaEvent[eventName]({
        eventLabel: buttonName,
        eventContent: data.title,
        productType: objectType,
        productName: data.title,
        productID: data.id,
        user_id: profile.id,
      })
    );
  };

  render() {
    const {
      isBuildingLoading,
      data,
      client,
      userUid,
      print,
      showInfo,
      t,
      profile,
      objectType,
      ...rest
    } = this.props;
    const { id, title, address, subregion, pavilions, favorite, update } = data || {};
    let year, quarter;

    if (isBuildingLoading) {
      return (
        <div
          className={cn(client ? styles.BuildingTitleClient : styles.BuildingTitle, {
            [styles.BuildingTitlePrint]: print,
          })}
        >
          <div className={styles.Container}>
            <div className={styles.WireframeTop}>
              <span></span>
              <span></span>
            </div>
            <div className={styles.WireframeBottom}>
              <div className={styles.WireframeButtonCollections}></div>
              <div className={styles.WireframeButtonFavor}></div>
              <div className={styles.WireframeButtonPrint}></div>
              <div className={styles.WireframeButtonChess}></div>
            </div>
          </div>
          <Loader active={this.props.building.isLoading} />
        </div>
      );
    }

    const { building } = rest;
    const buildingInfo = {
      pavilions: data.pavilions,
      title: data.title,
      address: data.address,
      subregion: data.subregion.name,
      imageId: data.image ? data.image.id : null,
      is_verified: data.is_verified,
      status: data.status,
    };

    let check = 20994; // 2099 г. 4 кв.
    const finished = (pavilions || []).some((pavilion) => {
      const { construction_finished, year_built, construction_ending } = pavilion;
      const current = Number(`${year_built}${construction_ending}`);
      if (year_built && construction_ending && check > current) {
        check = current;
        year = year_built;
        quarter = construction_ending;
      }
      return construction_finished;
    });
    const deadline =
      buildingInfo.status == 3
        ? t('components.header.buildingTitle.almostFinished')
        : finished
        ? t('components.header.buildingTitle.finished')
        : year === 0
        ? t('components.header.buildingTitle.inProgress')
        : year && quarter
        ? `${quarter} / ${year}`
        : '';

    let updateTime;
    if (update) {
      if (print) {
        updateTime = updateStringPrint(update);
      } else if (updateString(update).indexOf('Сегодня') == 0) {
        updateTime = t('components.header.buildingTitle.today');
      } else {
        updateTime = updateString(update);
      }
    }

    const renderInfo = () =>
      isSectionAllowed('nameAddress') ? (
        <div className={styles.LeftInfo}>
          <div className={styles.ObjectName}>
            <span>
              {showInfo === '0' ? t('components.header.buildingTitle.lot', { id }) : title}
            </span>
            <div className={styles.Status}>
              {buildingInfo.is_verified && (
                <img
                  className={styles.Verified}
                  alt={t('components.header.buildingTitle.verified')}
                  title={t('components.header.buildingTitle.verified')}
                  src={iconVerified}
                />
              )}
              {data.view_action ? (
                <div className={styles.PromoLabel}>
                  {t('components.header.buildingTitle.promo')}
                </div>
              ) : null}
              {deadline && (
                <div
                  className={cn(
                    buildingInfo.status == 3
                      ? styles.AlmostFinished
                      : finished
                      ? styles.Green
                      : styles.Yellow,
                    styles.StatusBlock
                  )}
                >
                  {deadline}
                </div>
              )}
            </div>
          </div>
          <span
            className={cn(styles.ObjectAddress, {
              [styles.ObjectAddressShare]:
                location.href.includes('/nbref/') || location.href.includes('/ncollection/'),
            })}
          >
            {`${subregion ? subregion.name + (address && showInfo !== '0' ? ', ' : '') : ''}${
              address && showInfo !== '0' ? address : ''
            }`}
          </span>
        </div>
      ) : null;

    return (
      <div
        className={cn(client ? styles.BuildingTitleClient : styles.BuildingTitle, {
          [styles.BuildingTitlePrint]: print,
        })}
      >
        <div className={styles.Container}>
          {data ? (
            client ? (
              <div className={styles.Inner}>{renderInfo()}</div>
            ) : (
              renderInfo()
            )
          ) : (
            <div className={styles.WireframeTop}>
              <span></span>
              <span></span>
            </div>
          )}

          {data ? (
            <div
              className={styles.UpdatedTime}
              data-tip={t('components.header.buildingTitle.updatedAt')}
              data-for="global"
            >
              {!print ? <img alt="icon" src={iconUpdate} /> : null}
              <span>
                {print ? (
                  <span className={styles.UpdatedTimeTextPrint}>
                    {t('components.header.buildingTitle.updatedFrom')}
                  </span>
                ) : null}
                {updateTime}
              </span>
            </div>
          ) : null}

          {/* {print ? <img src={logoPrint} alt="" className={styles.PrintLogo}/> : null} */}
          {data ? (
            !client && (
              <div className={styles.Buttons}>
                <div
                  className={styles.InaccuracyReportButtonWrap}
                  onClick={() =>
                    this.handleTrackEvent({
                      eventName: 'buildingTitleButtonsClick',
                      buttonName: 'soobshchit_o_netochnosti',
                    })
                  }
                >
                  <InaccuracyReport
                    building={data}
                    className={styles.InaccuracyReportWrap}
                    profile={profile}
                    objectType={objectType}
                  />
                </div>
                <div className={styles.AddToFavoritesButtonWrap}>
                  <Collections
                    onClick={() => {
                      this.sendEvent('Web_Card_Add_Selection');
                      this.handleTrackEvent({
                        eventName: 'buildingTitleButtonsClick',
                        buttonName: 'v_podborku',
                      });
                    }}
                    building={building}
                    className={styles.CollectionWrap}
                    profile={profile}
                    objectType={objectType}
                  />
                  <button
                    className={cn(styles.AddToFavoritesButton, { [styles.Active]: favorite })}
                    onClick={() => {
                      this.props[favorite ? 'removeFromFavorites' : 'addToFavorites'](
                        { buildingId: id, userUid },
                        { buildingName: title, data },
                        { profileId: profile.id, objectType }
                      );
                      this.sendEvent(
                        favorite ? 'Web_Card_Remove_Favorites' : 'Web_Card_Add_Favorites'
                      );
                      this.handleTrackEvent({
                        eventName: 'buildingTitleButtonsClick',
                        buttonName: 'v_izbrannoe',
                      });
                    }}
                    data-tip={t('components.header.buildingTitle.addToFavorites')}
                    data-for="global"
                  >
                    {favorite ? (
                      <img src={iconHeartActive} alt="" />
                    ) : (
                      <img src={iconHeart} alt="" />
                    )}
                  </button>
                </div>
                <div className={cn(styles.ShareButtonWrap, styles.Hide1120)}>
                  <ShareButton
                    onClick={() => {
                      this.sendEvent('Web_Card_Share');
                      this.handleTrackEvent({
                        eventName: 'buildingTitleButtonsClick',
                        buttonName: 'podelitsya',
                      });
                    }}
                    building={this.props.building}
                    profile={profile}
                    objectType={objectType}
                    tooltip={t('components.header.buildingTitle.share')}
                  />
                </div>
                <div
                  className={cn(styles.PrintButtonWrap, styles.Hide1120)}
                  onClick={() => {
                    this.sendEvent('Web_Card_Print');
                    this.handleTrackEvent({
                      eventName: 'buildingTitleButtonsClick',
                      buttonName: 'pechat_informacii',
                    });
                  }}
                >
                  <Print
                    {...rest}
                    buildingInfo={buildingInfo}
                    profile={profile}
                    objectType={objectType}
                    tooltip={t('components.header.buildingTitle.print')}
                  />
                </div>
                <div
                  className={styles.ChessLinkWrap}
                  onClick={() => {
                    this.sendEvent('Web_Card_Checkerboard');
                    this.handleTrackEvent({
                      eventName: 'buildingTitleButtonsClick',
                      buttonName: 'shahmatka',
                    });
                  }}
                >
                  <ChessLink {...rest} className={styles.ChessLink} />
                </div>
              </div>
            )
          ) : (
            <div className={styles.WireframeBottom}>
              <div className={styles.WireframeButtonCollections}></div>
              <div className={styles.WireframeButtonFavor}></div>
              <div className={styles.WireframeButtonPrint}></div>
              <div className={styles.WireframeButtonChess}></div>
            </div>
          )}
        </div>
        <Loader active={this.props.building.isLoading} />
      </div>
    );
  }
}

const buildingTitleSelector = createSelector(
  (state, props) => props.building.data || state.building.data,
  (state) => state.profile.hash,
  (state) => state.privacy.withClient,
  (data, userUid, withClient) => ({
    data,
    userUid,
    withClient,
  })
);

export default connect(buildingTitleSelector, { addToFavorites, removeFromFavorites })(
  withTranslation()(BuildingTitle)
);



// WEBPACK FOOTER //
// ./src/components/Header/BuildingTitle/BuildingTitle.js